module.exports = __webpack_public_path__ + "static/img/IMG_1809_03.0de1bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_1809_03.png
// module id = +B/Z
// module chunks = 1